export enum ChatbotPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
